// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:46:39

export default {
  "id": "jelly-tower-crush",
  "slug": "jelly-tower-crush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b3b89257a045429d8c1cf79d118efcd9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b3b89257a045429d8c1cf79d118efcd9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jelly Tower CRUSH",
      "description": "You can tap to clear the jelly of the same color as the ball.\nClearing jelly will cause more jelly to collapse and disappear.\nClear the objective before you run out of moves.\nUse bombs to clear a lot at once!",
      "instructions": "Tap to erase jelly.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "balance",
        "colorful",
        "cute",
        "jelly",
        "physics"
      ]
    },
    "zh-CN": {
      "title": "果冻塔 撕毁",
      "description": "您可以点击清除与球颜色相同的果冻。\n清除果冻会导致更多果冻倒塌并消失。\n在用完步数前完成目标。\n使用炸弹一次性清除大量果冻！",
      "instructions": "点击消除果冻。",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "平衡",
        "多彩",
        "可爱",
        "果冻",
        "物理"
      ]
    },
    "zh-TW": {
      "title": "果冻塔擊碎",
      "description": "您可以點擊清除與球同色的果冻。\n清除果冻會導致更多果冻倒塌並消失。\n在用盡步數前完成目標。\n使用炸彈一次清除大量果冻！",
      "instructions": "點擊以消除果冻。",
      "genres": [
        "配對3"
      ],
      "tags": [
        "平衡",
        "多采多姿",
        "可愛",
        "果冻",
        "物理學"
      ]
    },
    "zh-HK": {
      "title": "果冻塔擊毀",
      "description": "你可以按鍵清除與球同色的果冻。\n清除果冻會導致更多果冻崩潰並消失。\n在用盡步數前完成目標。\n使用炸彈一次清除大量果冻！",
      "instructions": "按鍵抹去果凍。",
      "genres": [
        "匹配三"
      ],
      "tags": [
        "平衡",
        "多彩",
        "可愛",
        "果冻",
        "物理"
      ]
    },
    "ja": {
      "title": "ジェリー・タワー クラッシュ",
      "description": "ボールと同じ色のジェリーをタップして消去できます。\nジェリーを消去すると、さらにジェリーが崩れ落ちて消えます。\n手数を使い切る前に目標を達成してください！\n一気に多くを消去するために爆弾を使用してください！",
      "instructions": "ジェリーをタップして消します。",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "バランス",
        "カラフル",
        "可愛い",
        "ジェリー",
        "物理"
      ]
    },
    "ko": {
      "title": "젤리 타워 CRUSH",
      "description": "필요한 색상의 젤리를 탭하여 클리어하세요.\n젤리를 클리어하면 더 많은 젤리가 무너지고 사라집니다.\n이동 횟수가 다되기 전에 목표를 클리어하세요!\n폭탄을 사용하여 한 번에 많이 클리어하세요!",
      "instructions": "젤리를 지우려면 탭하세요.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "균형",
        "다양한 색상",
        "귀엽다",
        "젤리",
        "물리학"
      ]
    },
    "fr": {
      "title": "Tour Gélatine CRASHER",
      "description": "Vous pouvez cliquer pour enlever la gélatine de la même couleur que la balle.\nL'effacement de la gélatine entraînera le effondrement et la disparition de plus de gélatine.\nEffacez l'objectif avant de vous épuiser en coups.\nUtilisez les bombes pour effacer beaucoup en une fois !",
      "instructions": "Touchez pour effacer la gélatine.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "équilibrage",
        "coloré",
        "mignon",
        "jelly",
        "physique"
      ]
    }
  }
};
